/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-07-01 16:01:06
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2021-09-21 11:16:32
*/

require('./ui.scss');
import { CommonDialer } from './dialer';
import { core } from '../core';
import { gtag } from '../utils/gtag';

let moved = false
let skipClick = false;
let pressTmr;
let dragTmr;
const vgipButton = require('./button');

const postDialer = (dialer: CommonDialer) => {
  core.dialer = dialer;
  window.addEventListener('message', (event) => {
    // tslint:disable-next-line: max-line-length
    const origin = event.origin || (event as any).originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
    if (origin !== location.origin) {
      return; //ignore msgs from external pages
    }
    if (event && event.data && event.data.action) {
      if (event.data.action === 'vgScDialExternal') {
        dialer.placeCall(event.data.phoneNumber, event.data.entityRef);
      }
    }
  });
}

const initStandalone = (provider, features, ccDomain?: string, ccAccount?: string) => {
  const vgipDialer: CommonDialer = new CommonDialer(provider, true, features, ccDomain, ccAccount);
  const position = () => {
    const D = 86;
    let top = (window.innerHeight - D);
    const vBottom = localStorage.getItem('vBottom');
    if (vBottom) {
      top = window.innerHeight - parseInt(vBottom, 10);
      if (top < 30) {
        top = 30;
      }
    }
    vgipButton.style.top = ((top > window.innerHeight - D) ? window.innerHeight - D : top) + 'px';
    let left = window.innerWidth - D;
    const vRight = localStorage.getItem('vRight');
    if (vRight) {
      left = window.innerWidth - parseInt(vRight, 10);
      if (left < 30) {
        left = 30;
      }
    }
    vgipButton.style.left = ((left > window.innerWidth - D) ? window.innerWidth - D : left) + 'px';

    vgipDialer.positionStandalone(top, left);
    vgipDialer.setVisibility(false);
  }

  const dragMove = (e) => {
    moved = true;
    if (e.clientY >= 28 && e.clientY < window.innerHeight - 28) vgipButton.style.top = e.clientY - 28 + 'px';
    if (e.clientX >= 28 && e.clientX < window.innerWidth - 28) vgipButton.style.left = e.clientX - 28 + 'px';
  }
  const dragStart = () => {
    moved = false;
    dragTmr = setTimeout(() => {
      window.addEventListener('mousemove', dragMove, true);
      window.addEventListener('mouseup', dragStop, false);
    }, 100);
    skipClick = false;
    pressTmr = setTimeout(() => {
      skipClick = true;
    }, 1000);
  }

  const dragStop = () => {
    clearTimeout(pressTmr);
    window.removeEventListener('mousemove', dragMove, true);
    window.removeEventListener('mouseup', dragStop, false);
    if (moved) {
      localStorage.setItem('vTop', vgipButton.offsetTop.toString());
      localStorage.setItem('vLeft', vgipButton.offsetLeft.toString());
      localStorage.setItem('vBottom', (window.innerHeight - vgipButton.offsetTop).toString());
      localStorage.setItem('vRight', (window.innerWidth - vgipButton.offsetLeft).toString());
      position();
    }
  }

  vgipButton.onclick = () => {
    if (!moved && !skipClick) {
      clearTimeout(pressTmr);
      setTimeout(() => {
        dragStop();
        vgipButton.classList.add('active');
        vgipDialer.focus();
        vgipDialer.setVisibility(true);
      }, 100);
    }
  }
  vgipButton.onmousedown = dragStart;
  vgipButton.oncontextmenu = (e) => {
    e.preventDefault();
    return false;
  }
  position();
  document.body.appendChild(vgipButton);
  vgipButton.appendChild(vgipDialer.frame);
  window.addEventListener('resize', (e) => {
    position();
  });
  if (provider === 'cc') {
    vgipDialer.frame.style.width = '200px';
    vgipDialer.frame.style.height = '398px';
  } else {
    vgipDialer.frame.style.width = '260px';
    vgipDialer.frame.style.height = '440px';
  }
  postDialer(vgipDialer);
}

const initInContainer = (dialerContainer, provider, features, ccDomain?: string, ccAccount?: string) => {
  const vgipDialer: CommonDialer = new CommonDialer(provider, false, features, ccDomain, ccAccount);
  dialerContainer.appendChild(vgipDialer.frame);
  postDialer(vgipDialer);
}

export class DialerUI {
  provider: 'cc' | 'uc';
  mode: 'dot' | any;
  loadPromise: Promise<any>;
  constructor(config: any = {}) {
    // console.log('SDK init DialerUI', config);
    this.provider = config.provider === 'cc' ? 'cc' : 'uc';
    if (config.mode !== 'dot') {
      const dialerContainer = document.querySelector(config.container || '[vonage-dialer-container], .vonage-dialer-container');
      if (dialerContainer) {
        initInContainer(dialerContainer, this.provider, config.features, config.ccDomain, config.ccAccount);
      } else {
        if (config.container) {
          console.error(`Can't find a container element with query selector '${config.container}'. Fallback to 'dot' mode.`);
        }
        initStandalone(this.provider, config.features, config.ccDomain, config.ccAccount);
      }
    } else {
      initStandalone(this.provider, config.features, config.ccDomain, config.ccAccount);
    }
    this.loadPromise = core.dialer.loadPromise;
    this.loadPromise.then(() => {
      gtag('event', 'page_view', {
        page_title: `ContactPad ${this.provider.toUpperCase()}`
      });
    });
  }
}
